import { useStaticQuery, graphql } from "gatsby";
import { getOriginalLocale } from "@helpers/GlobalHelpers";
import useLocale from "./useLocale";
import { UserLang } from "@constants/common";
import { useMemo } from "react";

export const useFetchChapterSlug = () => {
	const { currentLanguage } = useLocale();

	const graphqlData = useStaticQuery(graphql`
        query {
            aepsyCms {
                chaptersDE: chapters(pagination: { limit: 100 }, locale: "de-CH") {
                    slug
                    locale
                    navOrder
                    navLabel
                    subNavLabel
                }
                chaptersEN: chapters(pagination: { limit: 100 }, locale: "en") {
                    slug
                    locale
                    navOrder
                    navLabel
					subNavLabel
                }
                chaptersFR: chapters(pagination: { limit: 100 }, locale: "fr-CH") {
                    slug
                    locale
                    navOrder
                    navLabel
					subNavLabel
                }
				chaptersIT: chapters(pagination: { limit: 100 }, locale: "it") {
                    slug
                    locale
                    navOrder
                    navLabel
					subNavLabel
                }
            }
        }
    `);

	const { aepsyCms } = graphqlData;

	const data = useMemo(() => {
		switch (currentLanguage) {
			case UserLang.English:
				return aepsyCms.chaptersEN;
			case UserLang.French:
				return aepsyCms.chaptersFR;
			case UserLang.Italian:
				return aepsyCms.chaptersIT;
			default:
				return aepsyCms.chaptersDE;
		}
	}, [aepsyCms, currentLanguage]);

	return {
		mainLinks: data
			.filter(
				(item: any) =>
					item?.navLabel && getOriginalLocale(item?.locale) === currentLanguage,
			)
			.sort((a, b) => a.navOrder - b.navOrder),
		subLinks: data
			.filter(
				(item: any) =>
					!item?.navLabel &&
					getOriginalLocale(item?.locale) === currentLanguage,
			)
			.sort((a, b) => a.navOrder - b.navOrder),
		mixLinks: data
			.filter(
				(item: any) =>
					item?.navLabel &&
					item?.subNavLabel &&
					getOriginalLocale(item?.locale) === currentLanguage,
			)
			.sort((a, b) => a.navOrder - b.navOrder),
	};
};
